<template>
  <div>
    <el-scrollbar class="app-main-scroll" ref="scrollBar">
      <section :class="anonymous?'anonymous-main':'app-main'">
        <!-- <transition name="fade-transform" mode="out-in"> -->
          <keep-alive :include="cachedViews">
            <router-view :key="$route.fullPath" @handleConnect="handleConnect" @handleLink="handleLink" ref="activeView"/>
          </keep-alive>
        <!-- </transition> -->
      </section>
    </el-scrollbar>
  </div>
</template>

<script>
import ReportDialog from '@/components/ReportDialog/index.vue'
export default {
  name: 'AppMain',
  components: {
    ReportDialog
  },
  props: {
    anonymous: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    cachedViews() {
      const arr = this.$router.options.routes.map(r => {
        if (r.meta) {
          if (!r.meta.noCache) {
            return r.name
          }
        }
      })
      return arr
    },
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // },
    canKeepAlive() {
      return !(this.$store.state.tagsView.visitedViews.length === 1)
    }
  },
  methods: {
    handleReportDialogClose() {
      this.reportDialogVisible = false
    },
    handleLink(dataRow, model, reportTitle) {
      this.$emit('handleLink', dataRow, model, reportTitle)
    },
    // handleConnect(dataRow, model, connectData, reportTitle) {
    //   this.$emit('handleConnect', dataRow, model, connectData, reportTitle)
    // },
    handleDecisionClick(decisionId) {
      this.$router.push('/dashboard')
      this.$nextTick(() => {
        this.$refs.activeView.showDecision(decisionId)
      })
    },
    refreshData(decisionId) {
      this.$refs.activeView.refreshData(decisionId)
    },
    handleConnect(dataRow, model, connectData, reportTitle, mode) {
      this.$emit('handleConnect', dataRow, model, connectData, reportTitle, mode)
    }
  }
}
</script>

<style scoped>
.app-main {
  /*88 = tag+toolbar+copyright  */
  height: calc(100vh - 88px);
  min-height: calc(100vh - 88px);
  position: relative;
}
.anonymous-main{
  height: 100vh;
  position: relative;
}
</style>
